module.exports = {
  siteMetadata: {
    title: '一楼一凤 161f',
    shortTitle: '一楼一凤',
    author: '凤博士',
    description:
      '一楼一凤, 161f.com 是全国最全的小姐信息平台, 外围女工作室, 一夜情, 约炮性息, 本地交友',
    keywords: '小姐信息,兼职女,外围女,狼友,一夜情,约炮,全国楼凤,脱单,本地交友',
    siteUrl: 'https://161f.com',
    siteLogo: '',
    siteRss: '/rss.xml',
    siteMap: '/sitemap.xml',
  },
  googleAnalyticsID: 'G-NVE606L03N',
  GTM: {
    id: '',
  },
  disqusShortname: '161f',
  themeColor: '#f39',
  backgroundColor: '#ffe6e3',
}
